import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { useIntl } from 'react-intl';

import './DatePicker.scss';

import { messages } from '../../../_shared/i18n/messages';

const propTypes = {

	/**
	 * The input name.
	 */
	name: PropTypes.string,

	/**
	 * The input date value (as a MomentJS object).
	 */
	value: PropTypes.instanceOf(moment),

	/**
	 * The input placeholder text (if any).
	 */
	placeholder: PropTypes.string,

	/**
	 * True, if the input date value is invalid.
	 */
	isInvalid: PropTypes.bool.isRequired,

	/**
	 * True, if the input date value is required.
	 */
	isRequired: PropTypes.bool.isRequired,

	/**
	 * Callback to handle changes to the selected date.
	 */
	onChange: PropTypes.func.isRequired,

};

const defaultProps = {
	isInvalid: false,
	isRequired: false,
};

const DatePicker = (props) => {

	const {
		name,
		value,
		placeholder,
		isInvalid,
		isRequired,
		onChange,
	} = props;

	const intl = useIntl();

	return (
		<div className={`tc-datepicker ${isInvalid ? 'is-invalid' : ''}`}>
			<ReactDatePicker
				id={name}
				selected={value ? value.toDate() : null}
				placeholderText={
					placeholder ||
					intl.formatMessage(messages.TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_DATE)
				}
				isClearable={!isRequired}
				onChange={(newValue) => onChange(newValue ? moment(newValue) : null)} />
		</div>
	);

};

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;

export default DatePicker;
